var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.board.boardNo != null && !_vm.isLoading)?_c(_vm.isComponent,{tag:"component",attrs:{"board":_vm.board,"grpList":_vm.grpList,"depth":_vm.depth,"tabindex":_vm.tabindex}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }